import { Component } from "@/decorators";
import SetorModel from "@/models/setorModel";
import setorService from "@/services/setorService";

import EditComponentBase from "../editComponentBase";

@Component({
    components: {},
})
export default class SetorEditComponent extends EditComponentBase<SetorModel> {
    private async beforeMount() {
        await this.setPropsCached(setorService, "setor", new SetorModel());
    }
}
